<template>
  <div class="ps-card">
    <div class="ps-head">
      <span class="ps-title"><i class="pi pi-id-card"></i> اشتراكاتي</span>
      <router-link to="/my-subscriptions" class="ps-all">عرض الكل <i class="pi pi-angle-left"></i></router-link>
    </div>

    <div v-if="loading" class="ps-loading"><i class="pi pi-spin pi-spinner"></i></div>

    <template v-else>
      <div class="ps-stats">
        <router-link to="/my-subscriptions" class="ps-stat ps-stat--green">
          <span class="ps-stat__num">{{ activeCount }}</span>
          <span class="ps-stat__lbl">مفعّل</span>
        </router-link>
        <router-link to="/my-subscriptions" class="ps-stat ps-stat--red">
          <span class="ps-stat__num">{{ expiredCount }}</span>
          <span class="ps-stat__lbl">منتهي</span>
        </router-link>
      </div>

      <!-- Quick renew for expired/expiring -->
      <div v-if="renewable.length" class="ps-renew">
        <div class="ps-renew__label">تجديد سريع</div>
        <button v-for="s in renewable" :key="s.id" class="ps-renew__btn" @click="renew(s)">
          <span>{{ s.product_label }}</span>
          <i class="pi pi-refresh"></i>
        </button>
      </div>

      <div v-if="!subs.length" class="ps-empty">
        لا توجد اشتراكات بعد.
        <router-link to="/courses" class="ps-browse">تصفّح الكورسات</router-link>
      </div>
    </template>
  </div>
</template>

<script>
import { subscriptionService } from '@/services/subscriptionService.js';

const TYPE_QUERY = { Course: 'course', AcademicYear: 'academic_year' };

export default {
  name: 'ProfileSubscriptions',
  data() { return { subs: [], loading: true }; },
  computed: {
    activeCount() { return this.subs.filter(s => s.status === 'active').length; },
    expiredCount() { return this.subs.filter(s => s.status === 'expired').length; },
    renewable() { return this.subs.filter(s => s.status === 'expired').slice(0, 3); },
  },
  methods: {
    renew(s) {
      const t = TYPE_QUERY[String(s.subscribable_type).split('\\').pop()] || 'course';
      this.$router.push({ path: '/subscribe', query: { type: t, id: s.subscribable_id, plan: s.plan_type } });
    },
    async load() {
      this.loading = true;
      try { this.subs = await subscriptionService.mySubscriptions(); }
      catch { this.subs = []; }
      finally { this.loading = false; }
    },
  },
  mounted() { this.load(); },
};
</script>

<style scoped>
.ps-card { background: #fff; border: 1px solid rgba(5, 22, 41,.1); border-radius: 20px; padding: 1.2rem; margin-bottom: 1.5rem; }
.ps-head { display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem; }
.ps-title { font-weight: 800; color: #111827; display: inline-flex; align-items: center; gap: .4rem; }
.ps-title .pi { color: #051629; }
.ps-all { color: #051629; text-decoration: none; font-weight: 700; font-size: .82rem; }
.ps-loading { text-align: center; padding: 1rem; color: #051629; }
.ps-stats { display: grid; grid-template-columns: 1fr 1fr; gap: .8rem; }
.ps-stat { text-decoration: none; border-radius: 14px; padding: 1rem; text-align: center; display: block; }
.ps-stat--green { background: rgba(34,197,94,.08); }
.ps-stat--red { background: rgba(239,68,68,.07); }
.ps-stat__num { display: block; font-size: 1.6rem; font-weight: 800; }
.ps-stat--green .ps-stat__num { color: #16a34a; }
.ps-stat--red .ps-stat__num { color: #dc2626; }
.ps-stat__lbl { font-size: .8rem; color: #6B7280; }
.ps-renew { margin-top: 1rem; }
.ps-renew__label { font-size: .78rem; color: #94a3b8; margin-bottom: .5rem; }
.ps-renew__btn { display: flex; justify-content: space-between; align-items: center; width: 100%; background: #f1f5f9; border: none; border-radius: 10px; padding: .6rem .9rem; margin-bottom: .4rem; font-weight: 700; color: #374151; cursor: pointer; }
.ps-renew__btn .pi { color: #051629; }
.ps-empty { text-align: center; color: #94a3b8; font-size: .85rem; padding: .5rem; }
.ps-browse { display: block; margin-top: .4rem; color: #051629; text-decoration: none; font-weight: 700; }
</style>
